import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  Icon,
  Table,
  Button,
  message,
  Checkbox,
  notification,
  Input,
  Spin,
  Select,
  Tag
  // Pagination,
} from "antd";
import { Translate } from "react-translated";
import "./ManageScheduler.css";
import moment from "moment";
import axios from "axios";
import CommonGrid from "../../Dashboard/common-grid";
import ActionButtonRenderer from "./ActionButtonRenderer";
import Cookies from "js-cookie";
import F from "../../../Functions";
import DeleteRSUserModal from '../parts/delete-rs-user-modal'
import Pagination from '../../../components/pagination'
import { useBoundStore } from "../../../store/useBoundStore";
// two deactivation modal called one steps and two steps 
import DeactivateReviewSchedulerModalTwoSteps from "../parts/DeactivateModalForReviewer";
import DeactivateReviewSchedulerModalOneStep from "../../../components/deativate-review-scheduler";
import DownArrowIcon from "../../../scenes/LandingPage/images/new/down-arrow.png";

// assets
import RefreshIcon from "../../../assets/refresh-icon.png";
import { withRouter } from "react-router-dom";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import {
  GET_ROLES_API, GET_RS_USERS_API, MANAGE_SCHEDULER_LOAD_USERS_API_URL,
  // activated imports api url 
  RS_ALL_AGENCIES_API_URL, CHECK_BEFORE_DEACTIVATE_API,
  AGENCY_UNCLICK_REVIEW_API_URL,
  SWITCH_USER_ROLE_API_URL,
  API_CHECK_BEFORE_REMOVE_ROLE_PROSPECT_API,
  API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API,
  UPDATE_RFS_AGENCY_ASSOC,
  UPDATE_FS_AGENCY_ASSOC,
  RS_AGENCIES_ASSOC,
  RFS_AGENCIES_ASSOC,
  FS_AGENCIES_ASSOC,
  API_CHECK_BEFORE_REMOVE_ROLE_REVIEW_API
} from "../../../utils/Api_enums";
import { debounceQuery, EA, FOLLOWUP, getFullUserType, PROSPECT, removeHeaderTitle, REVIEW, REVIEWSCHEDULER, rolesFilter, TYPE_OF_CALL, TYPE_TO_FILTER_BY_EMAIL, TYPE_TO_FILTER_BY_FIRST_NAME, TYPE_TO_FILTER_BY_LAST_NAME, UNASSIGN_TRANSFER_REQUIRED, USER_TYPE_DROPDOWN, VONBOARDER, VONSCHEDULER } from "../../../utils/Constants";
import CustomHeader from "../../../CommonHeader/CustomHeader";
// import UnlinkUserModal from "../parts/unlink-user-modal";
import NewUnlinkModal from "../parts/NewUnlinkModal";

// activated scheduler imports 
import DataHandler from "../../../utils/DataHandler";
import ActivatedAgencyModal from "../../SuperAdmin/Modals/ActivatedAgencyModal/ActivatedAgencyModal";
import CustomModal from "../../../Common-Modal/CustomModal";
import TransferAllBfiles from "../parts/TransferAllBfiles";
import { TextFilter } from "ag-grid-community";


const { Search } = Input;
const { Option } = Select;


export const BUTTON_CONSTANTS = {
  edit_user: { label: "Edit User", key: "edit_user" },
  transfer_ownership: {
    label: "Transfer Agency",
    key: "transfer_ownership",
  },
  switch_to_REVIEWSCHEDULER: {
    // label: "Switch to Scheduler",
    label: "Switch to Review Scheduler",
    key: "switch_to_REVIEWSCHEDULER",
  },
  switch_to_VONBOARDER: {
    label: "Switch to Scheduler",
    // label: "Switch to FollowUp Specialist",
    key: "switch_to_VONBOARDER",
  },
  switch_to_VONSCHEDULER: {
    label: "Switch to Scheduler",
    // label: "switch_to_VONSCHEDULER",
    key: "switch_to_VONSCHEDULER",
  },
  unlink_user: {
    label: "Transfer B File",
    // label: "unlink user",
    key: "unlink_user",
  },

  //  activated tables new changes 
  // activated table button added here 
  deActivated: { label: "Deactivate", key: "de_activate" },
  agencies: { label: "Agencies", key: "agencies" },
};

const ManageSchedulers = (props) => {

  // console.log("props ManageSchedulers",props)
  const debounceRef = useRef(null);

  const { userType } = useBoundStore((state) => ({
    userType: state.userType,
  }));

  const { location } = props;
  const roleMap = {
    Lead: "Prospect",
    Opportunity: "FollowUp",
    Review: "Review",
  };
  const [currentState, setCurrentState] = useState({
    loading: true,
    users: [],
    unlink_user_modal: false,
    transfer_all_bfiles_modal: false,
    loggedin: props.auth.user,
    user: {},
    page: 1,
    total_pages: 0,
    updatedUser: {},
    delete_rs_user_modal: false,
    assign_users_modal: false,
    data: [],
    searchText: "",
    filterColumnValue: "",
    filterColumnField: "",
    rowData: null,
    show_deactivate_rs_modal: false,
    rs_users: [],
    // new states added from activated scheduler for decativation and agencies 
    agencies_modal: false,
    agencies_modal_loading: false,
    agencies: [],
    user_agencies: [],
    show_deactivate_rs_modal_one_step: false,

    // totrigger user api modal and check checkbox state 
    sortOrders: "",
    showBfileMsgModal: false


  });
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const searchTimeout = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selectRef = useRef(null);
  const [paginationState, setPaginationState] = useState({
    page: 1,
    pageSize: 5,
  });


  const [selectedUserType, setSelectedUserType] = useState([]);
  const [roles, setRoles] = useState([]);

  const [sortOrders, setSortOrders] = useState({});

  // state for localefield
  const [localField, setLocalField] = useState("updated_on");
  // state for localorder
  const [localOrder, setLocalOrder] = useState("desc")
  const resetHandlers = useRef([]);



  const handleFilter = (field, value) => {
    setCurrentState(prev => ({
      ...prev,
      filterColumnValue: null,
      filterColumnField: null,
      page: 1
    }));

    if (field === 'type_of_Call') {
      setSelectedUserType(value);
      setCurrentState(prev => ({
        ...prev,
        selectedUserType: value.map(item => roleMap[item] || item),
        page: 1
      }));
    } else {
      setCurrentState(prev => ({
        ...prev,
        filterColumnValue: value,
        filterColumnField: field,
        page: 1
      }));
    }

    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      loadUsers(1);
    }, 500);
  };


  const handleSort = (field) => {
    let newOrder;
    setSortOrders((prev) => {
      const currentOrder = prev[field] || "asc";
      newOrder = currentOrder === "asc" ? "desc" : "asc";
      return { ...prev, [field]: newOrder };
    });
    setLocalOrder(newOrder);
    setLocalField(field);
    // loadUsers()
  };



  const CustomTooltip = (props) => {
    return (
      <div style={{
        background: "rgba(0, 0, 0, 0.8)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        maxWidth: "200px",
        textAlign: "center"
      }}>
        {props.value}
      </div>
    );
  };

  // console.log("manageSchedulers",manageSchedulers)

  // --- Filter popover reset logic ---

  const handleFilterResetHandler = (resetFn) => {
    resetHandlers.current.push(resetFn);
  };

  const coleDef = [
    {
      headerClass: 'custom-ag-header',
      headerName: "First Name",
      valueGetter: (params) => `${params.data.first_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["first_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["First Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "first_name",
        sortOrder: sortOrders["first_name"],
        handleSort,
        handleFilter,
        placeholder: TYPE_TO_FILTER_BY_FIRST_NAME,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler
      }),
      colId: 'first_name',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Last Name",
      valueGetter: (params) => `${params.data.last_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["last_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Last Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "last_name",
        sortOrder: sortOrders["last_name"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler,
        placeholder: TYPE_TO_FILTER_BY_LAST_NAME,
      }),
      colId: 'last_name',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Email", field: "email", sortable: true,
      // filter: true ,
      width: 300,
      sortOrder: sortOrders["email"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Email"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "email",
        sortOrder: sortOrders["email"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler,
        placeholder: TYPE_TO_FILTER_BY_EMAIL,
      }),
      colId: 'email',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "User Type",
      field: "user_type",
      sortable: false,
      filter: false,
      headerComponentParams: (params) => ({
        headers: ["User Type"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "user_type",
        handleFilter,
        showPopOver: true,
        inputType: "select",
        options: F.getUserType(),
        handleFilterResetHandler
      }),
      colId: 'user_type',
      headerComponent: CustomHeader,
      cellRendererFramework: (params) => {
        const userType = params.value;
        let displayUserType = params.value;

        if (userType === "REVIEWSCHEDULER") {
          displayUserType = "RS";
        } else if (userType === "LSP") {
          displayUserType = "LSP";
        } else if (userType === "VONBOARDER") {
          displayUserType = "FS";
        } else if (userType === "VONSCHEDULER") {
          displayUserType = "RFS";
        }

        return (
          <div>
            <span
              style={{
                backgroundColor: "rgba(22, 72, 151, 0.12)",
                color: "#000",
                padding: "5px 5px",
                borderRadius: "7px",
              }}
            >
              {/* {params.value} */}
              {displayUserType}
            </span>
          </div>
        );
      },
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Type of Call",
      field: "type_of_Call",
      sortable: false,
      filter: false,
      width: 210,
      headerComponentParams: (params) => ({
        headers: ["Type of Call"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "type_of_Call",
        handleFilter,
        showPopOver: true,
        inputType: "multiCheckbox",
        options: F.getTypeOFCall(),
        handleFilterResetHandler
      }),
      colId: 'type_of_Call',
      headerComponent: CustomHeader,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Actions",
      cellRendererFramework: ActionButtonRenderer,
      sortable: false,
      filter: false,
      // increase button width shown 
      width: 850,
      // cellRendererParams: {
      //   onButtonClick: (buttonType, data) =>
      //     handleButtonClick(buttonType, data),
      // },
      cellRendererParams: {
        onButtonClick: (buttonType, data) =>
          handleButtonClick(buttonType, data), // Pass as callback
        currentState,
      },
    },
  ];
  // const [rowData, setRowData] = useState([]);

  const switchUser = (data) => {
    const { user } = data;
    // console.log("user switch", data);
    notification.destroy();
    // this.setState({ loading: true });
    removeHeaderTitle();
    setCurrentState(prevState => ({ ...prevState, loading: true }))
    axios
      // .post("/api/switchuser/" + user.id)
      .post(SWITCH_USER_ROLE_API_URL + user.id)
      .then((res) => {
        // console.log("res switch user", res.data)
        // this.setState({ loading: false });
        setCurrentState(prevState => ({ ...prevState, loading: false }))
        if (res.data.success == true) {
          const user = res.data.user;
          const roleNames = res.data.user.roles.map(role => role.rolename);
          // console.log("roleNames-->", roleNames)
          localStorage.setItem('roles', JSON.stringify(roleNames));
          if (user.user_type == VONSCHEDULER || user.user_type == REVIEWSCHEDULER) {
            useBoundStore.getState().setRSFSCardFilters({ defaultToggleUserRole: REVIEWSCHEDULER, selectedToggleAPI: REVIEWSCHEDULER });
          } else if (user.user_type == VONBOARDER) {
            useBoundStore.getState().setRSFSCardFilters({ defaultToggleUserRole: VONBOARDER, selectedToggleAPI: VONBOARDER });
          }
          Cookies.set(
            "user_info",
            JSON.stringify({
              first_name: user.first_name,
              last_name: user.last_name,
              email: user.email,
              id: user.id,
              user_type: user.user_type,
              default_date: user.default_date,
              last_login: user.last_login,
              language: user.language,
              active: user.active,
            }),
            {
              secure: true,           //  HTTPS only
              sameSite: 'Lax',        // Add this — fixes the scan finding
              path: '/',              // explicit path
            }
          );
          // this.props.history.push('/dashboard')
          localStorage.setItem('sa_user_route', '/manage-users-new');
          props.history.push("/dashboard");
          window.location.reload();
        } else {
          message.error(F.translate(`Can't switch to the user.`));
        }
      })
      .catch(() => {
        // this.setState({ loading: false });
        setCurrentState(prevState => ({ ...prevState, loading: false }))
        message.error(F.translate(`Can't switch to the user.`));
      }).finally(() => {
        // this.setState({ loading: false });
        setCurrentState(prevState => ({ ...prevState, loading: false }))
      });
  };

  // activated schedulers functions 
  /**
* 
* @param {*} userData 
* @returns void
*  function check status before deactivate and open modal 
*  if Existing scheduler has no agencies/bfiles associated.
*  Hence could be deactivated
*/
  const checkStatusBeforeDeactivate = async (userData) => {
    try {
      const { data } = await axios.get(
        `${CHECK_BEFORE_DEACTIVATE_API}/${userData.user.id}`
      );
      // check if Existing scheduler has no agencies/bfiles associated. Hence could be deactivated
      if (data.deactivate) {
        setCurrentState((prevState) => ({
          ...prevState,
          show_deactivate_rs_modal_one_step: true,
          user: userData.user,
        }));

      } else if (data.deactivate === false) {
        message.error(F.translate(data.message));
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };



  const checkforReviewLeadOpportunityCall = async (data) => {
    try {
      setCurrentState(prev => ({ ...prev, loading: true }));
      const userRoles = data.user_roles.map(r => r.rolename);
      const apiRequests = [];
      if (userRoles.includes(PROSPECT)) {
        apiRequests.push(
          axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_PROSPECT_API}/${data.user.id}?role_filter=${PROSPECT}`)
        )
      } else {
        apiRequests.push(Promise.resolve({ data: { success: true, unclick: true } }));
      }

      if (userRoles.includes(FOLLOWUP)) {
        apiRequests.push(
          axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API}/${data.user.id}?role_filter=${FOLLOWUP}`)
        )
      } else {
        apiRequests.push(Promise.resolve({ data: { success: true, unclick: true } }));
      }


      if (userRoles.includes(REVIEW)) {
        apiRequests.push(
          axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_REVIEW_API}/${data.user.id}`)
        )
      } else {
        apiRequests.push(Promise.resolve({ data: { success: true, unclick: true } }));
      }

      const [resProspect, resFollowUp, resReview] = await Promise.all(apiRequests);

      const leadBlocked = resProspect && resProspect.data && resProspect.data.success && resProspect.data.unclick === false;
      const followUpBlocked = resFollowUp && resFollowUp.data && resFollowUp.data.success && resFollowUp.data.unclick === false;
      const reviewBlocked = resReview && resReview.data && resReview.data.success && resReview.data.unclick === false;

      // CASE 1 — any blocked → unlink modal
      if (leadBlocked || followUpBlocked || reviewBlocked) {
        setCurrentState(prev => ({
          ...prev,
          user: data.user,
          unlink_user_modal: true,
          rowData: data
        }));
        return;
      }

      // CASE 2 — none blocked → show noBfile message
      setCurrentState(prev => ({
        ...prev,
        showBfileMsgModal: true
      }));

    }
    catch (error) {
      console.log("error", error);
    }
    finally {
      setCurrentState(prev => ({ ...prev, loading: false }));
    }
  }


  // const checkforReviewLeadOpportunityCall = async (data) => {
  //   try {
  //     setCurrentState(prevState => ({ ...prevState, loading: true }))
  //     const [res1, res2] = await Promise.all([
  //       axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_PROSPECT_API}/${data.user.id}?role_filter=Prospect`),
  //       axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API}/${data.user.id}?role_filter=FollowUp`)
  //     ]);
  //     // show pop up modal only when both lead and opportunity transfered 
  //     if ((res1.data && res1.data.success && res1.data.unclick === false) ||
  //      (res2.data && res2.data.success && res2.data.unclick === false)) {
  //       setCurrentState(prevState => ({
  //         ...prevState,
  //         user: data.user,
  //         unlink_user_modal: true,
  //         rowData: data,
  //       }))
  //     } else {
  //       const resp = await axios.get(`${API_CHECK_BEFORE_REMOVE_ROLE_FOLLOW_UP_API}/${data.user.id}`)
  //       if (resp.data && resp.data.success && resp.data.unclick === false) {
  //         setCurrentState(prevState => ({
  //           ...prevState,
  //           user: data.user,
  //           transfer_all_bfiles_modal: true,
  //           rowData: data
  //         }))
  //       } else {
  //         setCurrentState(prevState => ({
  //           ...prevState,
  //           showBfileMsgModal: true
  //         }))
  //       }
  //     }
  //     // console.log("res Lead",res)
  //   } catch (error) {
  //     console.log("error", error)
  //   } finally {
  //     setCurrentState(prevState => ({ ...prevState, loading: false }))
  //   }
  // }



  const handleButtonClick = (buttonType, data) => {
    if (buttonType === BUTTON_CONSTANTS.unlink_user.key) {
      loadUserAgencies(data.user.id, data.user.user_type);
      checkforReviewLeadOpportunityCall(data);
      return;
    }

    else if (buttonType == BUTTON_CONSTANTS.transfer_ownership.key) {
      setCurrentState(prevState => ({
        ...prevState,
        user: data.user,
        delete_rs_user_modal: true,
        rowData: data
      }))
    } else if (buttonType === BUTTON_CONSTANTS.deActivated.key) {

      checkStatusBeforeDeactivate(data);

    } else if (buttonType === BUTTON_CONSTANTS.agencies.key) {
      setCurrentState((prevState) => ({
        ...prevState,
        agencies_modal: true,
        user: data.user,
        user_roles: data.user_roles && data.user_roles.map((role) => role.rolename) || []
      }));
      loadUserAgencies(data.user.id, data.user.user_type);
    } else {
      switchUser(data);
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    clearTimeout(debounceRef.current);

    const hasGlobalSearch = currentState && currentState.searchText &&
      currentState.searchText.trim() !== "";
    const hasColumnFilter =
      (currentState && currentState.filterColumnField &&
        currentState.filterColumnField.trim() !== "") &&
      (currentState && currentState.filterColumnValue &&
        currentState.filterColumnValue.trim() !== "");

    debounceRef.current = setTimeout(() => {
      if (hasGlobalSearch || hasColumnFilter) {
        debounceQuery(() => loadUsers(currentState.page || 1), 500);
      } else {
        loadUsers(currentState.page || 1);
      }
    }, 500);

    return () => {
      clearTimeout(debounceRef.current);
    };
  }, [
    currentState.page,
    location.state,
    localField,
    localOrder,
    currentState.searchText,
    currentState.filterColumnField,
    currentState.filterColumnValue,
    selectedUserType,
  ]);


  useEffect(() => {
    const getRoles = async () => {
      const { data: { roles } } = await axios.get(GET_ROLES_API);
      setRoles(roles.map(item => {
        return {
          label: TYPE_OF_CALL[item.rolename],
          value: TYPE_OF_CALL[item.rolename],
          role_id: item.role_id,
          // checked:false, 
        }
      }))
    }
    getRoles();
  }, [])


  const getTypeOFCall = (user) => {
    const roles = user.roles;
    if (roles.length > 0) {
      const updatedRoles = roles.map((role) => TYPE_OF_CALL[role.rolename]);
      // console.log("updatedRoles",updatedRoles)
      return updatedRoles.join(",")
    }
    return ""
  }


  // const loadUsers = async (page) => {
  //   const historyState = location;
  //   const filters = [];

  //   filters.push({
  //     name: "active",
  //     op: "==",
  //     val: 1
  //   },
  //     {
  //       or: [
  //         { name: "user_type", op: "==", val: "VONBOARDER" },
  //         { name: "user_type", op: "==", val: "REVIEWSCHEDULER" },
  //         { name: "user_type", op: "==", val: "VONSCHEDULER" }
  //       ]
  //     }
  //   );

  const loadUsers = async (page = 1) => {
    let url = `${MANAGE_SCHEDULER_LOAD_USERS_API_URL}?page=${page}`;
    const searchWord = currentState.searchText.trim();
    const searchTextOnCol = currentState && currentState.filterColumnValue &&
      currentState.filterColumnValue.trim();
    const filterColumnField = currentState && currentState.filterColumnField
      && currentState.filterColumnField.trim();
    if (searchWord) {
      url += `&search_word=${encodeURIComponent(searchWord)}`;
    }
    if (searchTextOnCol && filterColumnField) {
      const filterObj = {};
      filterObj[filterColumnField.toLowerCase()] = searchTextOnCol;
      url += `&filter_by_column_name=${encodeURIComponent(JSON.stringify(filterObj))}`;
    }
    if (localField) {
      url += `&sort_by=${encodeURIComponent(localField)}`;
    }
    if (localOrder) {
      url += `&sort_order=${encodeURIComponent(localOrder)}`;
    }


    if (selectedUserType.length > 0) {
      const selectedRoles = selectedUserType.map(role => roleMap[role] || role);
      url += `&role_filter=${selectedRoles.join(",")}`;
    }


    // Set the page number
    // const nPage = page === undefined ? 1 : page;

    // // Build the API URL with existing filters and new filters
    // // let url = `${MANAGE_SCHEDULER_LOAD_USERS_API_URL}?q=${
    // //   JSON.stringify({ filters })
    // // }&page=${nPage}`;

    // let url = `${MANAGE_SCHEDULER_LOAD_USERS_API_URL}?q=${JSON.stringify({
    //   filters,
    //   order_by: [orderBy]  // Add the order_by here
    // })
    //   }&page=${nPage}`;



    //  const url = `${MANAGE_SCHEDULER_LOAD_USERS_API_URL}?q={"filters":[{"name":"active","op":"==","val":1},{"or":[{"name":"user_type","op":"==","val":"VONBOARDER"},{"name":"user_type","op":"==","val":"REVIEWSCHEDULER"},{"name":"user_type","op":"==","val":"VONSCHEDULER"}]}]}&page=${page}`
    try {
      setCurrentState((prevState) => ({
        ...prevState,
        loading: true,
      }));
      const res = await axios.get(url);
      // const users = res.data.objects;
      // console.log("res manage scheduler",res)
      const users = res.data.manage_users || [];
      const table_data = users.map(user => ({
        key: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        user_type: user.user_type,
        type_of_Call: getTypeOFCall(user),
        user_roles: user.roles,
        user: {
          id: user.id,
          user_type: user.user_type,

        }
      }))

      setCurrentState((prevState) => ({
        ...prevState,
        // loggedin: {
        //   ...prevState.loggedin,
        //   user_type: userType,
        // },
        data: table_data,
        page: res.data.current_page || 1,
        total_pages: res.data.pages || 0,
        loading: false,
        // users: users_list,
        data: table_data, // Add the newly constructed data to the state
        page: res.data.page,
        total_pages: res.data.total_pages,
      }));


    } catch (error) {
      console.log(error)

    } finally {
      setCurrentState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }





  };

  const refreshInfo = () => {
    resetHandlers.current.forEach(reset => reset());
    setCurrentState(prevState => ({
      ...prevState,
      selectedUserType: [],
      searchText: "",
      filterColumnField: "",
      filterColumnValue: ""
    }))
    setSelectedUserType([]);
    localStorage.removeItem("agGridColumnState");

    if (gridColumnApi) {
      gridColumnApi.resetColumnState();
      gridColumnApi.resetColumnGroupState();
    }

    loadUsers(1);
  }

  // useEffect to trigger the debounced function when `search` state changes
  // useEffect(() => {
  //   if (currentState.searchText !== "") {
  //     clearTimeout(debounceRef.current);
  //     debounceRef.current = setTimeout(() => {
  //       debounceQuery(() => loadUsers(1), 500);
  //     }, 500);
  //   } else {
  //     loadUsers(1);
  //   }
  //   return () => {
  //     clearTimeout(debounceRef.current);
  //   };
  // }, [currentState.searchText, selectedUserType]);

  // calling the api to get list of rs users 
  const get_all_active_rs_except_deactivated_user = () => {
    // axios.get("/api/rs_active_users/" + user.id).then((res) => {
    axios.get(GET_RS_USERS_API).then((res) => {
      //   this.setState({
      //     // agencies: res.data,
      //     rs_users: res.data
      //   });
      setCurrentState((prevState) => ({
        ...prevState,
        rs_users: res.data,
      }));
    });
  };

  useEffect(() => {
    get_all_active_rs_except_deactivated_user()
  }, [])

  const handleSearch = (value) => {
    setCurrentState(prevState => ({
      ...prevState,
      searchText: value,
      page: 1 // make page 1 when do search 
    }))

    // debounceQuery(() => loadUsers(1), 500);

  }


  const customTagRender = (props) => {
    const { label, value, closable, onClose } = props;
    return (
      <Tag closable={closable} onClose={onClose}>
        {value}
      </Tag>
    );
  };

  const showDeactivateModalFunc = () => {
    setCurrentState(prevState => ({
      ...prevState,
      show_deactivate_rs_modal: true,
      delete_rs_user_modal: false
    }))
  }



  // activated scheduler code start ---------------------

  const loadUserAgencies = async (user_id, user_type) => {
    try {
      setCurrentState((prevState) => ({
        ...prevState,
        agencies_modal_loading: true,
      }));

      let url;

      if (user_type === VONSCHEDULER) {
        url = RFS_AGENCIES_ASSOC(user_id);
      } else if (user_type === VONBOARDER) {
        url = FS_AGENCIES_ASSOC(user_id);
      } else {
        url = RS_AGENCIES_ASSOC(user_id);
      }

      const res = await axios.get(url);

      const agencies = [];
      const agencyTypeMap = {};

      res.data.forEach((item) => {
        agencies.push(item.agency_id);
        agencyTypeMap[item.agency_id] = {
          Prospect: !!item.Prospect,
          FollowUp: !!item.FollowUp,
          Review: !!item.Review,
        };
      });

      setCurrentState((prevState) => ({
        ...prevState,
        agencies_modal_loading: false,
        user_agencies: agencies,
        agency_type_map: agencyTypeMap,
      }));
    } catch (error) {
      console.error("Error loading user agencies:", error);

      setCurrentState((prevState) => ({
        ...prevState,
        agencies_modal_loading: false,
      }));
    }
  };



  const updateAgencyTablesData = (agency_id, checked) => {
    var val = 0;
    if (checked) val = 1;
    axios
      .post(
        "/api/update_rs_agency_assoc/" +
        currentState.user.id +
        "/" +
        agency_id +
        "/" +
        val
      )
      .then(() => {
        loadUserAgencies(currentState.user.id, currentState.user.user_type);
      }).finally(() => {
        setCurrentState((prevState) => ({
          ...prevState,
          agencies_modal_loading: false,
        }));
      });
  }


  const callUpdateFsAgencyAssoc = async (agency_id, checked, updatedRow, setCurrentState) => {
    try {
      const user_id = currentState.user.id;
      const lead = updatedRow.type_of_call_checked.Prospect ? 1 : 0;
      const opportunity = updatedRow.type_of_call_checked.FollowUp ? 1 : 0;
      const isChecked = checked ? 1 : 0;

      const url = UPDATE_FS_AGENCY_ASSOC(user_id, agency_id, isChecked, lead, opportunity);
      const response = await axios.post(url);
      if (response.data.success) {
        await loadUserAgencies(currentState.user.id, currentState.user.user_type);
      } else {
        message.error((response && response.data.message));
        await loadUserAgencies(currentState.user.id, currentState.user.user_type);
      }
    } catch (error) {
      message.error(error);
    } finally {
      setCurrentState((prevState) => ({
        ...prevState,
        agencies_modal_loading: false,
      }));
    }
  };



  const callUpdateRFSgencyAssoc = async (agency_id, checked, updatedRow, setCurrentState) => {
    try {
      const user_id = currentState.user.id;
      const lead = updatedRow.type_of_call_checked.Prospect ? 1 : 0;
      const opportunity = updatedRow.type_of_call_checked.FollowUp ? 1 : 0;
      const review = updatedRow.type_of_call_checked.Review ? 1 : 0;
      const isChecked = checked ? 1 : 0;

      const url = UPDATE_RFS_AGENCY_ASSOC(user_id, agency_id, isChecked, lead, opportunity, review);
      const response = await axios.post(url);
      if (response.data.success) {
        await loadUserAgencies(currentState.user.id, currentState.user.user_type);
      } else {
        message.error((response && response.data.message));
        await loadUserAgencies(currentState.user.id, currentState.user.user_type);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setCurrentState((prevState) => ({
        ...prevState,
        agencies_modal_loading: false,
      }));
    }
  };

  const updateAgencyAssoc = async (data, checked, updatedRow) => {

    const agency_id = data.id;
    const user_type = data.userType;

    setCurrentState((prevState) => ({
      ...prevState,
      agencies_modal_loading: true,
    }));

    if (user_type == VONSCHEDULER) {
      await callUpdateRFSgencyAssoc(agency_id, checked, updatedRow, setCurrentState);
    } else if (user_type == VONBOARDER) {
      await callUpdateFsAgencyAssoc(agency_id, checked, updatedRow, setCurrentState);
    }

    else {
      if (checked === false) {
        try {
          const { data } = await axios.get(`${AGENCY_UNCLICK_REVIEW_API_URL}/${currentState.user.id}/${agency_id}`);
          if (data && data.success && data.unclick === false) {
            message.error(F.translate(data.message));
            return;
          } else {
            updateAgencyTablesData(agency_id, checked)
          }
        } catch (error) {
          console.log(error)
        } finally {
          setCurrentState((prevState) => ({
            ...prevState,
            agencies_modal_loading: false,
          }));
        }
      } else {
        updateAgencyTablesData(agency_id, checked)
      }
    }





  };

  // const loadagency = () => {
  //   // loadUsers(1); // making 2 api calls of same loadusers so commented 
  //   // set Review Scheduler List Callback to update
  //   DataHandler.setReviewSchedulerListCallback(loadUsers);
  //   setCurrentState((prevState) => ({
  //     ...prevState,
  //     loading: true
  //   }));
  //   // axios.get("/api/rs_all_agencies").then((res) => {
  //   axios.get(RS_ALL_AGENCIES_API_URL).then((res) => {
  //     //   this.setState({
  //     //     agencies: res.data
  //     //   });
  //     setCurrentState((prevState) => ({
  //       ...prevState,
  //       agencies: res.data,
  //     }))
  //   }).catch((err) => {
  //     console.log(err);
  //   }).finally(() => {
  //     setCurrentState((prevState) => ({
  //       ...prevState,
  //       loading: false
  //     }))
  //   });

  // };

  const handleCloseModal = () => {
    setCurrentState((prevState) => ({
      ...prevState,
      agencies_modal: false,
    }));
  }

  // useEffect(() => {
  //   loadagency();
  //   return () => DataHandler.setReviewSchedulerListCallback(null);
  // }, []);


  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }, []);

  const saveState = useCallback((params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }, []);



  // this will make checkbox checked and unchecked based on user agencies 
  useEffect(() => {
    if (currentState.agencies.length > 0) {
      const updatedAgencies = currentState.agencies.map((agency) => {
        const typeData = currentState.agency_type_map[agency.id] || {};
        return {
          ...agency,
          isChecked: currentState.user_agencies.indexOf(agency.id) >= 0,
          userType: currentState.user.user_type,
          type_of_call_checked: typeData
        }
      });
      setCurrentState((prevState) => ({
        ...prevState,
        agencies: updatedAgencies,
      }));
    }
  }, [currentState.user_agencies, currentState.sortOrders]);

  // activated scheduler code end ---------------------


  return (
    <div className="table-container">
      {/* Manage Schedulers header  */}
      <div className="table-container">
        {/* Manage Schedulers header */}
        <div className="manage-scheduler-header-container">
          <div>
            <Icon style={{ marginRight: 10, color: "#1890ff" }} type="team" />
            <span style={{ fontWeight: "600" }}>
              <Translate text="Manage Schedulers" />
            </span>
          </div>

          <div className="input-container manage-scheduler-input-container">
            {/* Search Input */}
            <div style={{ position: "relative" }} className="manage-scheduler-input-container">
              <Input
                placeholder="Search by Name"
                value={currentState.searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: "100%", paddingRight: "30px", minWidth: '170px' }}
                className="searchinput borderRadius-28"
              />
              {currentState.searchText ? (
                <Icon
                  type="close"
                  onClick={() => handleSearch("")}
                  className="icon-style right-10"
                />
              ) : (
                <Icon
                  type="search"
                  className="icon-style right-10"
                />
              )}
            </div>

            {/* Select Dropdown */}
            <div ref={wrapperRef} className="select-dropdown-container" >
              <Select
                ref={selectRef}
                open={dropdownOpen}
                onDropdownVisibleChange={(open) => setDropdownOpen(open)}
                value={selectedUserType}
                mode="multiple"
                placeholder="Select Type of Call"
                maxTagCount={1}
                onChange={(value) => setSelectedUserType(value)}
                // style={{
                //   width: "225px",
                //   // backgroundColor: "#fff",
                //   borderRadius: "20px",
                //   fontSize: "12px",
                //   paddingRight: "30px"
                // }}
                className="searchinput user_type_select manage-scheduler-searchinput"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                tagRender={customTagRender}
                optionLabelProp="value"
              >
                {roles.map((option) => (
                  <Option key={option.role_id} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
              <Icon
                type={dropdownOpen ? "up" : "down"}
                className="icon-style right-15"
                onClick={() => setDropdownOpen((prev) => !prev)}
              />
            </div>

            {/* Refresh Button */}
            <Button
              style={{ marginTop: "0px" }}
              type="primary"
              className="bg-164897 borderRadius-28 myrefresh-btn"
              onClick={refreshInfo}
            >
              <Icon type="reload" />
              Refresh
            </Button>
          </div>
        </div>
      </div>


      {/* Manage Schedulers Table  */}
      <div>
        {coleDef.length > 0 && Array.isArray(currentState.data) ? (
          <Spin spinning={currentState.loading}>
            <CustomAgGridTable
              onGridReady={onGridReady}
              onColumnMoved={saveState}
              onSortChanged={saveState}
              onFilterChanged={saveState}
              rowDatas={currentState.data}
              columnDefss={coleDef}
            // styles={{ height: "400px", minHeight: "380px" }}
            />
          </Spin>
        ) : (
          // <div className="ag-theme-material" style={{ height: "600px", width: "100%" }}>
          //   <AgGridReact
          //       columnDefs={coleDef}
          //       rowData={currentState.data}
          //       pagination={true}
          //       paginationPageSize={paginationState.pageSize} // Ensure it's set
          //       onPaginationChanged={onPaginationChanged}
          //   />
          // </div>
          <p className="Loader-container">
            <Spin size="medium" />
          </p>
        )}
      </div>
      <div className="pagination-div-container">
        <Pagination
          // style={{ padding: "5px 0px" }}
          className="pagination-container "
          current_page={currentState.page}
          total_pages={currentState.total_pages}
          onClick={(page) => {
            loadUsers(page);
          }}
        />
      </div>

      {/* Deleteuser Modal */}
      {currentState.delete_rs_user_modal ? (
        <DeleteRSUserModal
          history={props.history}
          showModal={currentState.delete_rs_user_modal}
          hideModal={() =>
            setCurrentState((prevState) => ({
              ...prevState,
              delete_rs_user_modal: false,
            }))
          }
          user={currentState.user}
          user_type={userType}
          refresh={() => loadUsers(1)}
          loggedin={currentState.loggedin}
          rowData={currentState.rowData}
          showDeactivateModalFunc={showDeactivateModalFunc}

        />
      ) : null}

      {/* unlink user modal */}

      {currentState.unlink_user_modal && (
        <NewUnlinkModal
          history={props.history}
          showModal={currentState.unlink_user_modal}
          hideModal={() =>
            setCurrentState((prevState) => ({
              ...prevState,
              unlink_user_modal: false,
            }))
          }
          user={currentState.user}
          refresh={() => loadUsers(1)}
          loggedin={currentState.loggedin}
          user_type={userType}
          rowData={currentState.rowData}
          user_agencies={currentState.user_agencies}
          agency_type_map={currentState.agency_type_map}
        />
      )}

      {/* transfer all bfiles modal */}
      {currentState.transfer_all_bfiles_modal && (
        <TransferAllBfiles
          history={props.history}
          showModal={currentState.transfer_all_bfiles_modal}
          hideModal={() =>
            setCurrentState((prevState) => ({
              ...prevState,
              transfer_all_bfiles_modal: false,
            }))
          }
          user={currentState.user}
          refresh={() => loadUsers(1)}
          loggedin={currentState.loggedin}
          user_type={userType}
          rowData={currentState.rowData}
        />
      )}


      {/* deactivation modal manage scheduler 2 step modal */}

      {
        <div>
          {currentState.show_deactivate_rs_modal ? (
            <DeactivateReviewSchedulerModalTwoSteps
              // history={this.props.history}
              showModal={currentState.show_deactivate_rs_modal}
              hideModal={() =>
                // this.setState({ show_deactivate_rs_modal: false })
                setCurrentState((prevState) => ({
                  ...prevState,
                  show_deactivate_rs_modal: false,
                }))
              }
              deactivatedUser={{
                ...currentState.user,
                ...currentState.rowData,
              }}
              rs_users={currentState.rs_users}
            // rs_users={activatedSchedulerState.rs_users}
            // agency_id={this.state.agency_id_von}
            />
          ) : null}
        </div>
      }


      {
        // console.log("manageCurrentState====>",currentState)
      }
      {/* new Agency Modal Component    agencies ActivatedScheduler */}
      {currentState.agencies_modal && (
        <ActivatedAgencyModal
          isVisible={currentState.agencies_modal}
          closeModal={handleCloseModal}
          agencies={currentState.agencies}
          user={currentState.user}
          agency_type_map={currentState.agency_type_map}
          title={<Translate text={`Agency Assignment`} />}
          // parentInstance={parentInstance}
          // passing setState function 
          setActivatedSchedulerState={setCurrentState}
          activatedSchedulerState={currentState}
          user_agencies={currentState.user_agencies}
          updateAgencyAssoc={updateAgencyAssoc}
          sortOrders={currentState.sortOrders}
          userRoles={currentState.user_roles}
        />
      )}



      <div>
        {/** Deactivate Review Scheduler Modal  ActivatedScheduler 1 step modal */}
        {currentState.show_deactivate_rs_modal_one_step ? (
          <DeactivateReviewSchedulerModalOneStep
            // history={this.props.history}
            showModal={currentState.show_deactivate_rs_modal_one_step}
            hideModal={() =>
              // this.setState({ show_deactivate_rs_modal: false })
              setCurrentState((prevState) => ({
                ...prevState,
                show_deactivate_rs_modal_one_step: false,
              }))
            }
            loadUsers={loadUsers}
            deactivatedUser={currentState.user}
            rs_users={[]}  // no passing rs users as we directly showing prompt to choose yes or no from user
          // agency_id={this.state.agency_id_von}
          />
        ) : null}
      </div>


      <CustomModal isVisible={currentState.showBfileMsgModal}
        width={"40%"}
        title="Transfer Ownership"
        setIsVisible={() => setCurrentState(prevState => ({
          ...prevState,
          showBfileMsgModal: false
        }))}
        footer={<Button
          className="borderRadius-28"
          onClick={() => {
            setCurrentState(prevState => ({
              ...prevState,
              showBfileMsgModal: false
            }))
          }}>
          <Translate text={`Cancel`} />
        </Button>
        }

      >
        <label>
          <b>
            <Translate
              text={"No associated B File was found to transfer ownership."}
            />
          </b>
        </label>
      </CustomModal>


    </div>
  );
};

export default withRouter(ManageSchedulers);



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/ManageSchedulers/ManageSchedulers.js